// app/views/components/shared/FrequencyBadge.tsx
import { Badge } from '@/components/ui/badge'

const FREQUENCY_LABELS: Record<string, string> = {
  monthly: 'Monthly',
  quarterly: 'Quarterly',
  semi_annual: 'Semi-Annual',
  annual: 'Annual',
  biennial: 'Biennial',
  triennial: 'Triennial',
}

type FrequencyBadgeProps = { frequency: string | null }

export function FrequencyBadge({ frequency }: FrequencyBadgeProps) {
  if (!frequency) return <Badge variant="outline" className="font-normal text-xs">One-time</Badge>
  return <Badge variant="outline" className="font-normal text-xs">{FREQUENCY_LABELS[frequency] || frequency}</Badge>
}
